<script setup lang="ts">
import { computed } from 'vue'

import { formatMoney } from '@tix/common-utils'

import { getEnv } from '@/helpers/environment'

export type PriceDisplayProps = {
  value: number
}

const props = defineProps<PriceDisplayProps>()

const formattedPrice = computed(() => formatMoney(props.value, getEnv().portal.default_currency_code))
</script>

<template>
  <span>{{ formattedPrice }}</span>
</template>
